import { connect } from 'react-redux';
import YourPlan from './YourPlan';

import { CommonActions } from '@react-navigation/native';
import Navigation from '../../lib/navigation';
import { isExemptedFromTaxSelector } from '../../modules/Customer/selectors';
import { currentSubscriptionRenewalStatusSelector, currentSubscriptionSelector } from '../../modules/Dashboard';
import { initNewOffer, resetOfferState } from '../../modules/NewOffer/actions';
import { nextPlanSelector } from '../../modules/NextPlan';
import { currentSubscriptionPaymentAuthenticationsSelector } from '../../modules/Payment/selector';
import { isSubscriptionEnabledSelector } from '../../reducers/subscriptionSwitch';

function mapStateToProps(state) {
  const isSubscriptionEnabled = isSubscriptionEnabledSelector(state);
  const isExemptedFromTax = isExemptedFromTaxSelector(state);

  return {
    canChangePlan:
      isSubscriptionEnabled &&
      !state.subscription.isChangingMode &&
      currentSubscriptionRenewalStatusSelector(state) === 'ON',
    hasUnauthenticatedPayment: !!currentSubscriptionPaymentAuthenticationsSelector(state).length,
    isChangingMode: state.subscription.isChangingMode,
    subscription: currentSubscriptionSelector(state),
    nextPlan: nextPlanSelector(state),
    switchValue: isSubscriptionEnabled,
    isExemptedFromTax,
  };
}

const mapDispatchToProps = dispatch => ({
  changePlan: subscription => {
    if (subscription.hasUnavailableOffers) {
      Navigation.dispatch(CommonActions.navigate({ name: 'changePlan' }));
    } else {
      dispatch(
        initNewOffer({
          plan: subscription.plan,
          options: subscription.options,
          price: subscription.price,
        })
      );
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(YourPlan);
